import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Nav from "./Nav";
import Menu from "./Menu";
import Employee from "./Employee";
import Inventory from "./Inventory";
import SpecialEquipments from "./SpecialEquipments";
import Appointments from "./Appointments";
import Shifts from "../child_components/Shifts";
import Customer from "./Customer";
import Billing from "./Billing";
import AuditLog from "./AuditLog";
import Finance from "./Finance";
import Technician from "./Technicians";
import CarsAndManuals from "./CarsAndManuals";
import WorkOrderAuditLog from "./WorkOrderAuditLog";
// import EquipmentExtensionRequest from './EquipmentExtensionRequest';
import registerServiceWorker from "../swReg";
import Faqs from "./Faqs";
import Trainings from "./Trainings";
import Requests from "./Requests";
import Admin from "./Admin";
import Services from "./Services";
import myInfoAtom from "../atoms/myInfoAtom";
import loginStateAtom from "../atoms/loginStateAtom";
import { useRecoilState } from "recoil";
import { url } from "../utils/config";
import axios from "axios";
import { toast } from "react-toastify";
import Dashboard from "./Dashboard";
import GeneralEquipmentList from "./GeneralEquipmentList";
import DirectoryManagement from "./DirectoryManagement";
import OrderService from "./OrderService";
import Loader from "../reusable_components/Loader";
import navMenuStateAtom from "../atoms/navMenuState";
import FleetMedia from "../child_components/FleetMedia";
import FcQuote from "./FcQuote";

function Home() {
  const [loggedIn] = useRecoilState(loginStateAtom);
  const [myInfo, setMyInfo] = useRecoilState(myInfoAtom);
  const [showNavMenu, setShowNavMenu] = useRecoilState(navMenuStateAtom);

  useEffect(() => {
    registerServiceWorker();
  }, []);

  useEffect(() => {
    fetchMyInfo();
  }, [loggedIn]);

  async function fetchMyInfo() {
    if (Object.keys(myInfo).length === 0) {
      try {
        const reqUrl = url + "/my_info";
        const token = window.localStorage.getItem("token");
        const headers = { authorization: `bearer ${token}` };
        const { data } = await axios.get(reqUrl, { headers });
        setMyInfo(data.data);
        console.log(data);
      } catch (error) {
        toast.error(error.response.data.message, { autoClose: 3000 });
      }
    }
  }

  return (
    <>
      {/* Fixed Navbar */}
      <div className='fixed top-0 left-0 w-full z-50'>
        <Nav />
      </div>

      <Loader />

      <div
        className='flex h-screen pt-16'
        onClick={() => setShowNavMenu(false)}
      >
        {/* Fixed Sidebar */}
        <div className='w-[280px] fixed left-0 top-0 h-min-full bg-white shadow-md overflow-y-auto border-r'>
          <Menu />
        </div>

        {/* Main Content */}
        <div className='flex-1 ml-[280px] p-4 overflow-auto h-[calc(100vh-4rem)]'>
          <Routes>
            <Route path='/admin/*' element={<Admin />} />
            <Route path='/employee/*' element={<Employee />} />
            <Route path='/directory/*' element={<DirectoryManagement />} />
            <Route path='/order_service/*' element={<OrderService />} />
            <Route path='/inventory/*' element={<Inventory />} />
            <Route path='/special_equipments/*' element={<SpecialEquipments />} />
            <Route path='/general_equipments/*' element={<GeneralEquipmentList />} />
            <Route path='/fleet_media/*' element={<FleetMedia />} />
            <Route path='/requests/*' element={<Requests />} />
            <Route path='/services/*' element={<Services />} />
            <Route path='/appointments/*' element={<Appointments />} />
            <Route path='/customer/*' element={<Customer />} />
            <Route path='/finance/*' element={<Finance />} />
            <Route path='/trainings' element={<Trainings />} />
            <Route path='/billing' element={<Billing />} />
            <Route path='/fc_quotes' element={<FcQuote />} />
            <Route path='/technician' element={<Technician />} />
            <Route path='/cars_manuals' element={<CarsAndManuals />} />
            <Route path='/faqs' element={<Faqs />} />
            <Route exact path='/' element={<Dashboard />} />
            <Route path='/audit_log' element={<AuditLog />} />
            <Route path='/work_order_audit_log' element={<WorkOrderAuditLog />} />
          </Routes>
        </div>
      </div>
    </>
  );
}

export default Home;
